import { Box, Typography, useTheme } from '@mui/material';

import { getMasterPhotoById, getTeamImageById } from '@/helpers/images-helper';
import { toPriceInEuros } from '@/helpers/prices-helper';

import FixtureScore from '../../../shared/fixture-score';
import PlayerFullCard from '../../../shared/player-full-card';
import { getValorDeMercadoColor } from '@/helpers/mui-helper';

const JugadoresDrawerComponentHeader = ({
    id,
    name,
    teamId,
    status,
    statusLevel,
    marketValue,
    subida,
    points,
    averagePoints,
    fitness,
}) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                textAlign: 'center',
                display: 'flex',
                bgcolor: 'background.default',
                border: '1px solid',
                borderColor: 'border.main',
            }}
            pr={1}
        >
            <PlayerFullCard
                playerImage={getMasterPhotoById(id, 120)}
                name={name}
                width={80}
                height={80}
                teamImage={getTeamImageById(teamId)}
                status={status}
                statusLevel={statusLevel}
            />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 1,
                    justifyContent: 'space-between',
                    width: '100%',
                    alignItems: 'center',
                }}
            >
                <Box sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="body2" fontWeight={'bold'}>
                        {name}
                    </Typography>
                    <Typography fontSize={14} variant="body2">
                        {toPriceInEuros(marketValue)}
                    </Typography>
                    <Typography fontSize={14} variant="body2" color={getValorDeMercadoColor(subida, theme)}>
                        {toPriceInEuros(subida)}
                    </Typography>
                </Box>
                <Box sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="body2" color={theme.palette.text.primary} fontSize={14}>
                        Puntos:{' '}
                        <Typography component={'span'} fontSize={14}>
                            {points}
                        </Typography>
                    </Typography>
                    <Typography variant="body2" color={theme.palette.text.primary} fontSize={14}>
                        Media:{' '}
                        <Typography component={'span'} fontSize={14}>
                            {averagePoints?.toFixed(2)}
                        </Typography>
                    </Typography>
                    <Box display={'flex'} gap="4px">
                        {fitness?.map((f) => (
                            <FixtureScore key={f} score={f} isAvailable={true} />
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default JugadoresDrawerComponentHeader;
